<template>
  <div class="box">
    <!-- 通用页面底部 -->
    <section class='footer-bk' v-if="headerStyle == 1">
      <div class='footer-box'>
        <!-- <el-menu background-color='transparent' class='contact-list' mode='horizontal'> -->
        <div class='footer-nav'>
          <template v-for="(item, index) in this.footernav">
            <span :key="index" @click="gotoLink(item.url)">{{item.title}}</span>
          </template>
        </div>
        <div class='copyright'>版权所有：{{config.copyright}} | 联系方式：{{config.kefu_tel}}</div>
        <div class='call'>
          <span v-if="config.icp">网站备案：<a target="_blank" href="http://beian.miit.gov.cn">{{config.icp}}</a></span>
          <span v-if="config.telecom_business_license">&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;电信增值业务许可证：<span>{{config.telecom_business_license}}</span></span>
          <span v-if="config.human_resource_license">&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;人力资源服务许可证编号：<span>{{config.human_resource_license}}</span></span>
          <span v-if="config.site_config_public_security_record">&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
            <img src="../assets/images/ghs.png" alt="" >
            <a target="_blank" :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${config.site_config_public_security_record}`">{{ config.site_config_public_security_record }}</a>
          </span>
        </div>
        <div class='call'>
          <span>Copyright © 2020 {{ config.url }} All Right Reserved.</span>
        </div>
      </div>
    </section>
    <!-- 注册页面底部 -->
    <section v-if="headerStyle == 2" class="footer2-box">
      <p>
        <span @click="tapHrefAbout">关于我们</span> |
        <span @click="tapHrefCall">联系我们</span> |
        <span @click="tapHrefAdvertising">广告服务</span> |
        <span @click="tapHrefLink">友情链接</span> |
        <span @click="tapHrefHire">诚聘英才</span> |
        <span @click="tapHrefHelp">帮助中心</span> |
        <span @click="tapHrefSuggest">投诉与建议</span>
      </p>
      <p>版权所有：安徽易滁网络科技有限公司 皖B2-20110018 服务热线：
        <span>0550-3050550</span> 手机版</p>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      footernav: []
    };
  },
  computed: {
    ...mapGetters(['config'])
  },
  props: {
    headerStyle: {
      default: 1
    }
  },
  methods: {
    getNavigation() {
      this.$api.webConfig.getNavigation().then(res => {
        if (this.config.pc_footer_links && this.config.pc_footer_links.length) {
          this.footernav = this.config.pc_footer_links.map(i => {
            return { title: i.label, url: i.value }
          })
        } else {
          this.footernav = res[2].WebNavigations
        }
        // console.log(this.footernav)
      })
    },
    /* 关于我们 */
    tapHrefAbout() {
      this.$notify({
        title: '跳转',
        message: '关于我们'
      });
    },
    /* 联系我们 */
    tapHrefCall() {
      this.$notify({
        title: '跳转',
        message: '跳转到联系我们'
      });
    },
    /* 广告服务 */
    tapHrefAdvertising() {
      this.$notify({
        title: '跳转',
        message: '跳转到广告服务'
      });
    },
    /* 友情链接 */
    tapHrefLink() {
      this.$notify({
        title: '跳转',
        message: '跳转到友情链接'
      });
    },
    /* 诚聘英才 */
    tapHrefHire() {
      this.$notify({
        title: '跳转',
        message: '跳转到诚聘英才'
      });
    },
    /* 帮助中心 */
    tapHrefHelp() {
      this.$notify({
        title: '跳转',
        message: '跳转到帮助中心'
      });
    },
    /* 投诉与建议 */
    tapHrefSuggest() {
      this.$notify({
        title: '跳转',
        message: '跳转到投诉与建议'
      });
    },
    gotoLink(link) {
      location.href = link
    },
    gotoQQLink() {
      window.open(`https://wpa.qq.com/msgrd?v=3&uin=${this.config.kefu_qq}&site=qq&menu=yes`)
    }
  },
  created() {
    this.getNavigation()
  }
};
</script>

<style lang='less' scoped>
@media print {
  .footer-bk {
    display: none;
  }
}
.box {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
}
.footer-bk {
  width: 1150px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
}
.footer-bk .footer-box {
  margin: 20px auto;
  text-align: center;
  // width: 600px;
}
.footer-nav {
  margin-top: 20px;
  line-height: 40px;
}
.footer-nav span {
  padding: 0 10px;
  font-size: 12px;
  color: #676767;
  font-family: 'PingFang SC','Helvetica Neue','Hiragino Sans GB','Segoe UI','Microsoft YaHei','微软雅黑','sans-serif';
  cursor: pointer;
}
.footer-nav span:hover {
  color: #999999;
}
.footer-nav span:last-child {
  color: #EC6941;
}
.footer-bk .contact-list.el-menu--horizontal {
  overflow: hidden;
  border: 0;
}
.footer-bk .contact-list .el-menu-item {
  width: 85px;
}
.el-menu-item:active{
  color: #333;
  text-decoration: none;
  border:none!important;
}
.copyright {
  text-align: center;
  font-size: 12px;
  margin-top: 10px;
  color: #676767;
}
.call {
  text-align: center;
  font-size: 12px;
  margin-top: 10px;
  color: #676767;
}
/* footer2-box */
.footer2-box {
  width: 574px;
  height: 51px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
  margin: 0 auto;
  text-align: center;
}
.footer2-box p:nth-child(1) {
  margin-bottom: 25px;
}
.footer2-box p:nth-child(2) span {
  color: #EC6941;
}
.el-menu{
  margin-top: 30px;
}
.el-menu-item{
  text-align: center;
  color: #333;
  text-decoration: none;
  font-family: 'Microsoft Yahei', 'PingFang SC';
  padding: 0 10px;
  border:none!important;
}
.warn{
  color: #EC6941;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue